document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.upgrade-offer__button--no-thanks').forEach(function(button) {
    button.addEventListener('click', function() {
      var offerBox = button.closest('.upgrade-offer');
      if (offerBox) {
        offerBox.style.display = 'none';
      }
    });
  });

  document.querySelectorAll('.upgrade-offer__button--upgrade').forEach(function(button) {
    button.addEventListener('click', function() {
      var offerBox = button.closest('.upgrade-offer');
      if (!offerBox) {
        return;
      }
      var lineId = offerBox.dataset.lineId;
      var newVariantId = offerBox.dataset.newVariantId;
      var quantity = offerBox.dataset.quantity;
      upgradeCart(lineId, newVariantId, quantity);
    });
  });

  function upgradeCart(lineId, newVariantId, quantity) {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var lineItem = cart.items.find(function(item) {
          return item && item.key == lineId;
        });
        if (!lineItem) {
          console.error('Line item not found in the cart.');
          return;
        }

        var properties = lineItem.properties || {};
        var sellingPlanId = lineItem.selling_plan_allocation && lineItem.selling_plan_allocation.selling_plan ? lineItem.selling_plan_allocation.selling_plan.id : null;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: lineId,
            quantity: 0
          })
        })
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            console.log('Removed old variant from cart:', data);

            var item = {
              id: newVariantId,
              quantity: parseInt(quantity, 10),
              properties: properties
            };
            if (sellingPlanId) {
              item.selling_plan = sellingPlanId;
            }

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: [item]
              })
            })
              .then(function(response) {
                return response.json();
              })
              .then(function() {
                window.location.reload();
              })
              .catch(function(error) {
                console.error('Error adding new variant:', error);
              });
          })
          .catch(function(error) {
            console.error('Error removing old variant:', error);
          });
      })
      .catch(function(error) {
        console.error('Error fetching cart:', error);
      });
  }
});